var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "objective-form" }, [
    _c("h1", [_vm._v(_vm._s(_vm.$l10n.__("Créer un objectif")))]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "objective-form__wrapper" },
      [
        _c("preloader", {
          staticClass: "objective-form__loader",
          attrs: { display: _vm.loading }
        }),
        _vm._v(" "),
        _c("ObjectiveSectionDefine", {
          key: "objective-section-define-" + _vm.formKey,
          ref: "objective-section-define",
          attrs: {
            settings: _vm.defineDatas,
            errors: _vm.errors,
            isDuplicateForm: _vm.isDuplicateForm
          },
          on: { "update-rules": _vm.updateRules },
          model: {
            value: _vm.define,
            callback: function($$v) {
              _vm.define = $$v
            },
            expression: "define"
          }
        }),
        _vm._v(" "),
        _c("ObjectiveSectionDuration", {
          key: "objective-section-duration-" + _vm.formKey,
          ref: "objective-section-duration",
          attrs: { settings: _vm.durationDatas, errors: _vm.errors },
          on: { "update-rules": _vm.updateRules },
          model: {
            value: _vm.duration,
            callback: function($$v) {
              _vm.duration = $$v
            },
            expression: "duration"
          }
        }),
        _vm._v(" "),
        _c("ObjectiveSectionResult", {
          key: "objective-section-result-" + _vm.formKey,
          ref: "objective-section-result",
          attrs: {
            settings: _vm.resultDatas,
            errors: _vm.errors,
            selectedDuration: _vm.form.period,
            periodDateFormat: _vm.periodDateFormat
          },
          model: {
            value: _vm.result,
            callback: function($$v) {
              _vm.result = $$v
            },
            expression: "result"
          }
        })
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "objective-form-cta__container" },
      [
        _c("CompassButton", {
          staticClass: "objective-form-cta__button cancel",
          attrs: {
            label: _vm.$t.__("common.actions.cancel"),
            loading: _vm.loading,
            type: "secondary"
          },
          on: { click: _vm.goToObjectivesListingPage }
        }),
        _vm._v(" "),
        !_vm.isDuplicateForm
          ? _c("CompassButton", {
              staticClass: "objective-form-cta__button save-and-create",
              attrs: {
                label: _vm.$t.__(
                  "objectives.create.ObjectiveForm.save_and_create"
                ),
                loading: _vm.loading,
                type: "secondary"
              },
              on: {
                click: function($event) {
                  return _vm.validateAndSendForm(true)
                }
              }
            })
          : _vm._e(),
        _vm._v(" "),
        _c("CompassButton", {
          staticClass: "objective-form-cta__button save",
          attrs: {
            label: _vm.$t.__("common.actions.save"),
            loading: _vm.loading
          },
          on: {
            click: function($event) {
              return _vm.validateAndSendForm(false)
            }
          }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }